import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "startpage-services",
  class: "py-4"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Nästa tömning:", -1)
const _hoisted_4 = { class: "justify-self-end pe-5" }
const _hoisted_5 = { class: "pt-4" }


import router from '@/router'
import { useServicesStore } from '@/stores/serviceStore'
import customButton from '@/components/ui/custom-button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'startpageServices',
  props: {
  textClass: {
    type: Object
  },
  columnSizes: {
    type: Object
  }
},
  setup(__props) {

const servicesStore = useServicesStore()

const props = __props

function setServiceID (item: any) {
  servicesStore.setServiceID(item.key)
  router.push({ path: `/service/${item.key}` })
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", {
      class: _normalizeClass(__props.textClass?.h2)
    }, "Mina tjänster", 2),
    _createElementVNode("div", _hoisted_1, [
      (_unref(servicesStore).getStartpageSubset.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesStore).getStartpageSubset, (item) => {
              return (_openBlock(), _createBlock(_component_v_hover, {
                key: item.key
              }, {
                default: _withCtx(({ isHovering, props }) => [
                  _createVNode(_component_v_card, _mergeProps({
                    flat: "",
                    class: { 'on-hover': isHovering },
                    style: {
    '--v-hover-opacity': isHovering ? '0.025' : '0',
    'max-width': '750px',
  }
                  }, props, {
                    onClick: ($event: any) => (setServiceID(item))
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_item, { class: "py-2 px-0" }, {
                        append: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              icon: "mdi-arrow-right"
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "pa-0 ma-0 d-flex justify-even-spaceing" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(item.category), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_text, { class: "pa-0 ma-0" }, {
                            default: _withCtx(() => [
                              _hoisted_3,
                              _createTextVNode(" " + _toDisplayString(item.closestStartDateString), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040, ["class", "style", "onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(customButton, {
                text: 'Alla tjänster & abonnemang',
                href: '/case',
                "ref-type": 'internalRoute'
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})